/* eslint-disable max-len */
function TrashCanSvg(props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7314" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="black" />
        </mask>
        <g mask="url(#mask0_38017_7314)">
            <rect x="8.08765" y="7.35938" width="5.47297" height="1.09459" rx="0.547297" transform="rotate(90 8.08765 7.35938)" fill="#39404D" />
            <rect x="11.0066" y="7.35938" width="5.47297" height="1.09459" rx="0.547297" transform="rotate(90 11.0066 7.35938)" fill="#39404D" />
            <path d="M4.07422 5.17188V13.8881C4.07422 14.7165 4.74579 15.3881 5.57422 15.3881H12.4256C13.254 15.3881 13.9256 14.7165 13.9256 13.8881V5.17188" stroke="#39404D" strokeWidth="1.125" />
            <line x1="2.8125" y1="4.6875" x2="15.1875" y2="4.6875" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" />
            <line x1="6.9375" y1="2.8125" x2="11.0625" y2="2.8125" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" />
        </g>
    </svg>;
}

export default TrashCanSvg;
